import * as React from 'react';
import { SVGProps } from 'react';

const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 10.5h-1.5V6a4.5 4.5 0 1 0-9 0v4.5H6A1.5 1.5 0 0 0 4.5 12v9A1.5 1.5 0 0 0 6 22.5h12a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5ZM9 6a3 3 0 1 1 6 0v4.5H9V6Zm9 15H6v-9h12v9Z'
      fill='#444'
    />
  </svg>
);

export default SvgLock;
